var React = require('react');

function IconSocialYoutube (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.083,0S4.9,0,2.859.591h0A3.425,3.425,0,0,0,.543,3.1h0A40.254,40.254,0,0,0,0,9.925H0a40.249,40.249,0,0,0,.543,6.829h0a3.414,3.414,0,0,0,2.316,2.5h0c2.042.591,10.224.591,10.224.591h0s8.182,0,10.224-.591h0a3.416,3.416,0,0,0,2.311-2.5h0a39.823,39.823,0,0,0,.549-6.829h0A39.828,39.828,0,0,0,25.617,3.1h0A3.426,3.426,0,0,0,23.306.591h0C21.265,0,13.083,0,13.083,0Z","transform":"translate(0 0)","fill":"currentcolor","key":0}),React.createElement("path",{"d":"M0,6.6,8.8,3.3,0,0Z","transform":"translate(8.8 6.6)","fill":"#1b3155","key":1})]);
}

IconSocialYoutube.defaultProps = {"className":"svg-icon","viewBox":"0 0 26.4 22"};

module.exports = IconSocialYoutube;

IconSocialYoutube.default = IconSocialYoutube;
